import { Component } from '@angular/core';

@Component({
  selector: 'app-contactanos',
  templateUrl: './contactanos.component.html',
  styleUrls: [
    '../../../assets/css/footer-pages.css',
    './contactanos.component.css',
  ],
})
export class ContactanosComponent {}
